import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { UpdateEntry } from '../lib/types';

interface Props {
  update: UpdateEntry;
}

/**
 * Kartu untuk daftar "Baru Diupdate" — mirip DramaCard tapi tampilkan
 * jumlah episode baru sebagai badge overlay & label platform.
 */
export function UpdateCard({ update }: Props) {
  const [imgOk, setImgOk] = useState(true);
  const delta =
    update.previousEpisodes !== null
      ? update.totalEpisodes - update.previousEpisodes
      : 0;
  return (
    <Link
      to={`/drama/${update.platform}/${update.dramaId}`}
      className="group block"
      aria-label={update.title}
    >
      <div className="relative aspect-poster overflow-hidden rounded-lg bg-neutral-800">
        {update.cover && imgOk ? (
          <img
            src={update.cover}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform group-hover:scale-105"
            // 0-byte / gagal → tampilkan inisial judul, bukan kotak kosong.
            onError={() => setImgOk(false)}
            onLoad={(e) => {
              const img = e.currentTarget as HTMLImageElement;
              if (img.naturalWidth === 0) setImgOk(false);
            }}
          />
        ) : (
          <div className="grid h-full w-full place-items-center bg-gradient-to-br from-neutral-800 to-neutral-900 p-2 text-center text-neutral-400">
            <span className="line-clamp-3 text-xs font-medium">
              {update.title}
            </span>
          </div>
        )}
        {update.isNew && (
          <span className="absolute left-1.5 top-1.5 rounded bg-gold-grad px-1.5 py-0.5 text-[10px] font-extrabold text-gold-ink shadow">
            {update.previousEpisodes === null ? 'BARU' : 'NEW'}
          </span>
        )}
        {delta > 0 ? (
          <span className="absolute right-1.5 top-1.5 rounded bg-black/70 px-1.5 py-0.5 text-[10px] font-medium text-white backdrop-blur">
            +{delta} ep
          </span>
        ) : (
          <span className="absolute right-1.5 top-1.5 rounded bg-black/60 px-1.5 py-0.5 text-[10px] font-medium text-white backdrop-blur">
            {update.totalEpisodes} ep
          </span>
        )}
        <span className="absolute bottom-1.5 left-1.5 rounded bg-black/60 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white backdrop-blur">
          {update.platform}
        </span>
      </div>
      <h3 className="mt-2 line-clamp-2 text-sm font-medium leading-tight">
        {update.title}
      </h3>
    </Link>
  );
}
